import Instrument from "shared/games/instruments/Instrument";
import { Looop } from "../Looop";

/**
 * Frequencies
 */

export const eQAllowedFrequencies = ["bass", "lmid", "hmid", "high"] as const;
export type EQAllowedFrequencies = typeof eQAllowedFrequencies[number];
export function getEQAllowedFreq(unverifiedFreq: string) {
  if (!eQAllowedFrequencies.includes(unverifiedFreq as EQAllowedFrequencies)) {
    throw new Error(
      `Passed in 'unverifiedFeq' is not an allowed freq ${unverifiedFreq}`
    );
  }

  return unverifiedFreq as EQAllowedFrequencies;
}

/**
 * Gain
 */

export const eQAllowedGains = [10, 0] as const;
export type EQAllowedGains = typeof eQAllowedGains[number];
export function getEQAllowedGains(unverifiedGain: number) {
  if (!eQAllowedGains.includes(unverifiedGain as EQAllowedGains)) {
    throw new Error(
      `Passed in 'unverifiedGain' is not an allowed gain ${unverifiedGain}`
    );
  }

  return unverifiedGain as EQAllowedGains;
}

/**
 * Pan
 */
export const panAllowedValues = ["L", "LC", "C", "RC", "R"] as const;
export type AllowedPanValues = typeof panAllowedValues[number];

/**
 * Volume
 */

export const volumeAllowedValues = [-40, -32, -24, -16, -8, 0] as const;
export type VolumeAllowedValues = typeof volumeAllowedValues[number];

/**
 * Compressor
 */
export type CompressorAllowedValues = null | 7;

export interface MixPuzzle {
  id: number;
  slug: string;
  title: string;
  description: string;
  looop: Looop;
  updated_at: string;
  instruments: {
    [instrumentId: string]: MixPuzzleInstrument;
  };
}

export interface MixPuzzleInstrument {
  id: number;
  instrument: Instrument;
  volume: VolumeAllowedValues;
  pan: AllowedPanValues;
  eq_freq: EQAllowedFrequencies;
  eq_gain: EQAllowedGains;
  comp: CompressorAllowedValues;
}
